// Shared "nothing here yet" recipe for a list/section inside an already-
// chromed page (Assets, Versions, Players' recent matches, ...) - an icon
// tile, a title, an optional hint line and an optional call to action.
// Several project tabs had each hand-rolled a bare, differently-sized grey
// sentence for this instead; this is the in-page sibling of NotFoundScreen
// (ui-shared.tsx), which owns the same recipe for a whole-page "not found".
import type { CSSProperties, ReactNode } from 'react';

export function EmptyState({
  icon,
  title,
  hint,
  action,
  compact = false,
  style,
}: {
  icon: ReactNode;
  title: string;
  hint?: ReactNode;
  action?: ReactNode;
  /** Tighter padding for a slot with less room to give (an embedded card
   * rather than a whole tab's content area). */
  compact?: boolean;
  style?: CSSProperties;
}) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: 6,
        padding: compact ? '22px 20px' : '48px 20px',
        ...style,
      }}
    >
      <div
        aria-hidden="true"
        style={{
          width: 44,
          height: 44,
          marginBottom: 6,
          borderRadius: 12,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--ss-accent-soft)',
          color: 'var(--ss-accent)',
        }}
      >
        {icon}
      </div>
      <span style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--ss-text-2)' }}>{title}</span>
      {hint && <span style={{ fontSize: 12.5, color: 'var(--ss-text-3)', maxWidth: 360, lineHeight: 1.55 }}>{hint}</span>}
      {action && <div style={{ marginTop: 10 }}>{action}</div>}
    </div>
  );
}
